<div
  class="flex w-full flex-row items-center overflow-hidden"
  [class]="disabled() ? 'text-[var(--mat-sys-outline)]' : ''"
  [class]="!label() ? 'justify-center' : ''"
>
  <mat-checkbox
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    [disabled]="isDisabled()"
    color="primary"
    [id]="id() ?? ''"
    [tabIndex]="tabDisabled() ? '-1' : '0'"
  >
  </mat-checkbox>
  <label
    (click)="changeValue()"
    [class]="disabled() ? 'text-[var(--mat-sys-outline)]' : ''"
    class="truncate"
    style="text-align: left"
  >
    {{ label() | siaTranslate }}
  </label>
</div>
@if (showBottomMargin()) {
  <mat-hint
    class="w-full pl-5 text-xs"
    sia-error-hint
    [statusMessage]="statusMessage()"
    [statusMessages]="statusMessages()"
  ></mat-hint>
}
